import request from '@/utils/request'
import axios from 'axios'

// Select Options
export function getOptionListByType(type) {
  return request({
    url: 'Employee/featureList',
    params: { key: type },
  })
}

export function getBrandList() {
  return request({
    url: 'RoleC/brandList',
  })
}

// EMPLOYEE
export function getEmployeeList(data) {
  return request({
    url: '/employee/list',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
    data: {
      keywords: data.keywords,
      filter: data.filters,
      sort: data.sort,
      cycle_id: data.cycle_id,
    },
  })
}
export function getEmployeeDetail(eId) {
  return request({
    url: `/employee/view?eId=${eId}`,
    method: 'post',
  })
}

export function getMemberDetail(mId) {
  return request({
    url: `/member/view?mId=${mId}`,
    method: 'post',
  })
}

export function addEmployee(data) {
  return request({
    url: '/employee/create',
    method: 'post',
    data,
  })
}

export function updateEmployee(eId, data) {
  return request({
    url: '/employee/update?eId=' + eId,
    method: 'post',
    data,
  })
}

export function changeEmployee(eId, data) {
  return request({
    url: '/employee/change?eId=' + eId,
    method: 'post',
    data,
  })
}
export function getEmployeeHistoy() {
  return request({
    url: '/Import/EmployeeHistory',
    method: 'post',
  })
}
export function importEmployeeData(data) {
  return request({
    url: '/Import/Employee',
    method: 'post',
    timeout: 1000 * 60,
    data,
  })
}
export function exportEmployeeData(token, cycle_id = 0) {
  // return request({
  //   url: '/Export/Employee',
  //   method: 'post',
  // })
  let data = {}
  if (cycle_id != 0) {
    data = {
      cycle_id,
    }
  }
  return axios({
    url: `/api/Export/Employee`,
    headers: {
      Authorization: token,
    },
    data,
    responseType: 'blob',
    method: 'post',
  })
}
export function confirmEmployeeUpload(data) {
  return request({
    url: `Import/ConfirmEmployee?fId=${data.fId.id}&cycle_id=${data.cycle_id}`,
    timeout: 1000 * 60,
    method: 'post',
  })
}
// WINDOW
export function getCycleList(data) {
  return request({
    url: '/Cycle/List',
    method: 'post',
    data,
  })
}
export function addCycle(data) {
  return request({
    url: '/cycle/create',
    method: 'post',
    data,
  })
}
export function updateCycle(data) {
  return request({
    url: `/cycle/update?id=${data.id}`,
    method: 'post',
    data,
  })
}
export function deleteCycle(id) {
  return request({
    url: `/cycle/delete?id=${id}`,
    method: 'post',
  })
}

export function publishCycle(id, offlineMode) {
  return request({
    url: `/cycle/publish?id=${id}${offlineMode !== undefined ? '&offline_mode=' + offlineMode : ''}`,
    method: 'post',
  })
}

export function publishLM(id, offlineMode) {
  return request({
    url: `/cycle/publishLM?id=${id}${offlineMode !== undefined ? '&offline_mode=' + offlineMode : ''}`,
    method: 'post',
  })
}

// Guide

export function getGuideHistory(data) {
  return request({
    url: 'Import/GuideHistory',
    method: 'post',
    data,
  })
}
export function confirmGuideUpload(urID) {
  return request({
    url: `import/ConfirmGuide`,
    method: 'post',
    data: {
      fId: urID,
    },
  })
}
// export function importGuideData(token) {
//   return axios({
//     url: '/Import/Guide',
//     headers: {
//       Authorization: token,
//     },
//     method: 'post',
//   })
// }

export function exportGuideData(token, id) {
  return axios({
    url: `/api/Export/Guide?id=${id}`,
    headers: {
      Authorization: token,
    },
    responseType: 'blob',
    method: 'post',
  })
}
export function renameGuide(fid, filename) {
  return request({
    url: `/Import/GuideRename?fId=${fid}`,
    method: 'post',
    data: { name: filename },
  })
}
export function deleteGuide(fid) {
  return request({
    url: `/import/guidedel?fId=${fid}`,
    method: 'post',
  })
}
export function exportLearningResource(token, id) {
  return axios({
    url: `/api/Export/LearningResource?id=${id}`,
    headers: {
      Authorization: token,
    },
    responseType: 'blob',
    method: 'post',
  })
}
export function renameLearningResource(fid, filename) {
  return request({
    url: `/Import/LearningResourceRename?fId=${fid}`,
    method: 'post',
    data: { name: filename },
  })
}
export function deleteLearningResource(fid) {
  return request({
    url: `/import/learningResourceDel?fId=${fid}`,
    method: 'post',
  })
}

export function getLearningResourceHistory(data) {
  return request({
    url: '/Import/LearningResourceHistory',
    method: 'post',
    data,
  })
}

export function getLearningRecordHistory(data) {
  return request({
    url: '/Import/LearningRecordHistory',
    method: 'post',
    data,
  })
}

//Permission
export function getEmployeePermissionList(data) {
  return request({
    url: '/RoleD/ListA',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
    data: {
      keywords: data.keywords,
      filter: data.filters,
      sort: data.sort,
    },
  })
}

export function getManagerPermissionList(data) {
  return request({
    url: '/RoleD/ListB',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
    data: {
      keywords: data.keywords,
      filter: data.filters,
      sort: data.sort,
    },
  })
}

export function getHRBPPermissionList(data) {
  return request({
    url: '/RoleD/ListC',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
    data: {
      keywords: data.keywords,
      filter: data.filters,
      sort: data.sort,
    },
  })
}

export function reOpenApplication(aid) {
  return request({
    url: `RoleD/ReOpenB?aId=${aid}`,
    method: 'post',
  })
}
export function reSetApplication(aid) {
  return request({
    url: `RoleD/ReOpenA?aId=${aid}`,
    method: 'post',
  })
}
export function disableEmployeeAccount(eid) {
  return request({
    url: `RoleD/CancelA?eId=${eid}`,
    method: 'post',
  })
}
export function disableManagerAccount(eid) {
  return request({
    url: `RoleD/CancelA?eId=${eid}`,
    method: 'post',
  })
}

export function getApplyDetail(aid) {
  return request({
    url: `RoleD/ViewA?aId=${aid}`,
    method: 'post',
  })
}

export function getRoleOptionsData(cycle_id) {
  return request({
    url: `RoleD/RetrieveRole?cycle_id=${cycle_id}`,
    method: 'get',
  })
}

export function transferEmployee(employee_ids, cycle_id, hrbp_id, lm_id) {
  return request({
    url: `RoleD/transfer`,
    method: 'post',
    data: {
      employee_ids,
      cycle_id,
      hrbp_id,
      lm_id,
    },
  })
}

export function getManagerInfo(lm_id) {
  return request({
    url: `RoleD/manager/info`,
    method: 'post',
    data: {
      lm_id,
    },
  })
}

export function getHRBPInfo(hrbp_id) {
  return request({
    url: `RoleD/hrbp/info`,
    method: 'post',
    data: {
      hrbp_id,
    },
  })
}

export function uploadFile(url, file) {
  const formData = new FormData()
  console.log(file)
  formData.append('file', file)
  return request({
    url,
    method: 'post',
    data: formData,
  })
}

export function uploadTwoLanguageFiles(url, file_en, file_cn) {
  const formData = new FormData()
  formData.append('file_en', file_en)
  formData.append('file_cn', file_cn)
  return request({
    url,
    method: 'post',
    data: formData,
  })
}

export function getRoleDListBrands(params) {
  return request({
    url: '/RoleD/ListBrands',
    method: 'get',
    params,
  })
}

export function getRoleDListLocations(params) {
  return request({
    url: '/RoleD/ListLocations',
    method: 'get',
    params,
  })
}

export function addManagerIdentityRightsForEmployee(mId) {
  return request({
    url: '/member/update',
    method: 'post',
    data: { mId },
  })
}

export function addEmployeeIdentityRightsForManager(data) {
  return request({
    url: '/member/update',
    method: 'post',
    data,
  })
}

export function updateEmployeeResult(data) {
  return request({
    url: '/RoleD/UpdateResult',
    method: 'post',
    data,
  })
}

export function batchUpdateEmployeeResult(data) {
  return request({
    url: '/employee/result/batch',
    method: 'post',
    data,
  })
}

export function exportResultTemplate(token, cycle_id) {
  return axios({
    url: `/api/RoleD/ExportResultsTemplate`,
    headers: {
      Authorization: token,
    },
    data: { cycle_id },
    responseType: 'blob',
    method: 'post',
  })
}

export function importResults(file, cycle_id) {
  const formData = new FormData()
  formData.append('file', file)
  if (cycle_id) {
    formData.append('cycle_id', cycle_id)
  }
  return request({
    url: '/RoleD/ImportResults',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
